import { Injectable, inject } from '@angular/core';
import { locale, loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';

import ptLocale from '../directives/locale/pt.json';
import esLocale from '../directives/locale/es.json';

@Injectable()
export class TranslationService {
    _claims = inject<any>('Claims' as any);

    private currentLang = 'en';
    private translations: any;

    constructor() {
        switch (this._claims.language) {
            case 'pt':
                this.translations = ptLocale;
                break;
            case 'es':
                this.translations = esLocale;
                break;
        }
    }

    setLanguage(lang: string) {
        this.currentLang = lang;
    }

    translate(key: string, blade: string): string {
        // Check if translations are loaded or it's the default English language
        if (!this.translations) {
            return key; // Return the original key if the language doesn't exist
        }
        // Get the translation for the given blade and key
        return this.translations[blade] && this.translations[blade][key]
            ? this.translations[blade][key]
            : key;
    }

    async loadDevExtremeMessages(): Promise<void> {
        if (this._claims.dxMessages) {
            try {
                const messages = this._claims.dxMessages;
                loadMessages(messages); // Load the messages into DevExtreme
                locale(this._claims.language); // Set the locale in DevExtreme
            } catch (error) {
                console.error('Failed to parse localization messages:', error);
            }
        } else {
            console.error('No localization messages found in claims.');
        }
    }
}

export function appInitializerFactory(
    translate: TranslateService,
    translationService: TranslationService,
) {
    return () => {
        translate.setDefaultLang(translationService._claims.language);
        return translate.use(translationService._claims.language).toPromise();
    };
}
